var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.73047C8.75 4.06199 8.8817 4.37993 9.11612 4.61435C9.35054 4.84877 9.66848 4.98047 10 4.98047C10.3315 4.98047 10.6495 4.84877 10.8839 4.61435C11.1183 4.37993 11.25 4.06199 11.25 3.73047C11.25 3.39895 11.1183 3.08101 10.8839 2.84659C10.6495 2.61216 10.3315 2.48047 10 2.48047C9.66848 2.48047 9.35054 2.61216 9.11612 2.84659C8.8817 3.08101 8.75 3.39895 8.75 3.73047ZM8.75 9.98047C8.75 10.312 8.8817 10.6299 9.11612 10.8644C9.35054 11.0988 9.66848 11.2305 10 11.2305C10.3315 11.2305 10.6495 11.0988 10.8839 10.8644C11.1183 10.6299 11.25 10.312 11.25 9.98047C11.25 9.64895 11.1183 9.33101 10.8839 9.09659C10.6495 8.86217 10.3315 8.73047 10 8.73047C9.66848 8.73047 9.35054 8.86217 9.11612 9.09659C8.8817 9.33101 8.75 9.64895 8.75 9.98047ZM8.75 16.2305C8.75 16.562 8.8817 16.8799 9.11612 17.1144C9.35054 17.3488 9.66848 17.4805 10 17.4805C10.3315 17.4805 10.6495 17.3488 10.8839 17.1144C11.1183 16.8799 11.25 16.562 11.25 16.2305C11.25 15.8989 11.1183 15.581 10.8839 15.3466C10.6495 15.1122 10.3315 14.9805 10 14.9805C9.66848 14.9805 9.35054 15.1122 9.11612 15.3466C8.8817 15.581 8.75 15.8989 8.75 16.2305Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.4046d55671116a9c1a0565d7a9083e2a.svg";
export { ForwardRef as ReactComponent };